/* Miras-ı Râşa — overlay header durum makinesi (Faz 2)
   Ölçüm kaynağı: phases/phase-2-armadillo-analysis.md §A4.
   - ~8px'te binary durum geçişi (şeffaf -> cam panel)
   - 10-50px arasında logo yüksekliğinin scroll'a bağlı sürekli interpolasyonu
   - Menü açıkken header zorla daralmış duruma geçer
   Bağımlılık yok. */
(function () {
  var header = document.querySelector('.miras-header--overlay');
  if (!header) return;

  var FLIP = 8; // durum geçiş eşiği (px)
  var FROM = 10; // interpolasyon başlangıcı
  var TO = 50; // interpolasyon bitişi
  var TALL = parseFloat(header.dataset.mirasLogoTall) || 30; // tepe logo yüksekliği (px)
  var SHORT = parseFloat(header.dataset.mirasLogoCompact) || 16; // daralmış (px)
  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  var ticking = false;
  var forcedCompact = false;

  function logoHeight(y) {
    if (y <= FROM) return TALL;
    if (y >= TO) return SHORT;
    return TALL - ((y - FROM) / (TO - FROM)) * (TALL - SHORT);
  }

  function apply() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var compact = forcedCompact || y > FLIP;

    if (compact) {
      header.setAttribute('data-miras-scrolled', '');
    } else {
      header.removeAttribute('data-miras-scrolled');
    }

    if (!DESKTOP.matches) {
      header.style.removeProperty('--miras-logo-height');
      return;
    }

    if (REDUCED.matches) {
      header.style.removeProperty('--miras-logo-height');
      return;
    }

    var h = forcedCompact ? SHORT : logoHeight(y);
    header.style.setProperty('--miras-logo-height', h.toFixed(2) + 'px');
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }

  /* Herhangi bir menü açıldığında header'ı daralmış duruma kilitle:
     mobil drawer ve masaüstü mega menü tetikleyicilerinin tamamı.
     Panelin üst konumu CSS'te --miras-header-height'tan türetilir
     (daralmış durumda 64px), böylece 500ms geçiş sırasında ara değer
     okunmaz. Dawn'ın kendi disclosure mantığına dokunulmaz. */
  var panels = [].slice.call(header.querySelectorAll('header-drawer details, header-menu details'));

  function syncForcedCompact() {
    forcedCompact = panels.some(function (d) {
      return d.hasAttribute('open');
    });
    apply();
  }

  panels.forEach(function (d) {
    new MutationObserver(syncForcedCompact).observe(d, {
      attributes: true,
      attributeFilter: ['open'],
    });
  });

  /* Dawn (details-disclosure.js) bu değişkeni ilk açılışta BİR KEZ yazıp
     bir daha güncellemiyor; bizim header yüksekliğimiz 126 <-> 64 arasında
     değiştiği için yanlış donabilirdi. Daralmış yüksekliği baştan yazıyoruz,
     Dawn'ın kodu `!== ''` kontrolünde erken çıkıyor. */
  function setHeaderBottom() {
    var compact = DESKTOP.matches ? SHORT + 48 : 56;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', compact + 'px');
  }
  setHeaderBottom();

  window.addEventListener('scroll', onScroll, { passive: true });
  DESKTOP.addEventListener('change', function () {
    setHeaderBottom();
    apply();
  });
  REDUCED.addEventListener('change', apply);
  apply();
})();
